var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:({ 'background-image': ("url(" + (_vm.url ? _vm.url : _vm.avatarPlaceholder) + ")") })},[(_vm.name)?_c('span',{staticClass:"sr-only"},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }